export default {
  submitLoading: false,
  awsAccountList: [],
  newManagedServices: {
    registrationStep: 'listing', // ie, listing, validation, onboarding, contact
    sfdcId: '',
    searching: false,
    searchMessage: '',
    searchError: false,
    selected: false,
    opportunityName: '',
    workloadTitle: '',
    submittedDate: '',
    oppregStatus: '',
    savingContact: false,
    accountRecord: {},
    noDiscount: false
  },
  managedServicesList: {
    registrationStep: 'listing', // ie, listing, validation, onboarding, contact
    listType: 'ManagedServices',
    selectedWorkload: [],
    loadingWorkloads: false,
    listWorkloadHeaders: [
      {
        sortable: true,
        text: 'Actions',
        value: ''
      },
      {
        sortable: true,
        text: 'Workload Title',
        value: 'Workload_Title'
      },
      {
        sortable: true,
        text: 'OppReg Req Date',
        value: 'OppReg_Req_Date'
      },
      {
        sortable: true,
        text: 'Workload Status',
        value: 'Workload_Status'
      },
      {
        sortable: true,
        text: 'Workload Type',
        value: 'Workload_type'
      }
    ],
    listHeaders: [
      {
        sortable: true,
        text: 'Actions',
        value: ''
      },
      {
        sortable: true,
        text: 'Opportunity Id',
        value: 'Opportunity_Id'
      },
      {
        sortable: true,
        text: 'AWS Accounts',
        value: 'AWS_Accounts'
      },
      {
        sortable: true,
        text: 'Description',
        value: 'Description'
      },
      {
        sortable: true,
        text: 'Status',
        value: 'Status'
      }
    ],
    listManagedServices: [],
    loadingList:false,
    workloads: [],
    setNextPageKey: ''
  },
  awsAccountValidation: {
    wbsCode: null,
    wbsValidating: false,
    wbsValidationMessage: '',
    wbsCodeValidated: false,
    wbsType: null,
    iwoCode: null,
    iwoValidating: false,
    iwoValidationMessage: '',
    iwoCodeValidated: false,
    agreed: false,
    submitting: false,
    savingForLater: false,
    savedForLater: false,
    isPromoCode: null,
    awsCredits: null
  },
  updateManagedServices: {
    showDialog: false,
    data: {}
  }
}
